import { loadScript, removeScript } from '@/shared/lib/analytics/scriptLoader'
import {
  configString,
  type AnalyticsEventProps,
  type AnalyticsProvider,
  type AnalyticsProviderConfig,
} from '@/shared/lib/analytics/types'

const SCRIPT_ID = 'cse-analytics-umami'

export function createUmamiProvider(): AnalyticsProvider {
  let ready: Promise<void> | null = null

  const whenReady = (run: () => void): void => {
    ready?.then(run).catch(() => undefined)
  }

  return {
    key: 'umami',
    load(config: AnalyticsProviderConfig): void {
      ready = loadScript(SCRIPT_ID, configString(config, 'script_url'), {
        'data-website-id': configString(config, 'website_id'),
        'data-auto-track': 'false',
        'data-do-not-track': 'true',
        'data-exclude-search': 'true',
        'data-exclude-hash': 'true',
      })
      ready.catch(() => undefined)
    },
    unload(): void {
      ready = null
      removeScript(SCRIPT_ID)
      delete window.umami
    },
    pageview(path: string): void {
      whenReady(() => {
        window.umami?.track((props: Record<string, unknown>) => ({
          ...props,
          url: path,
          title: document.title,
        }))
      })
    },
    track(name: string, props?: AnalyticsEventProps): void {
      whenReady(() => {
        window.umami?.track(name, props)
      })
    },
  }
}
